import React, { Component } from 'react';
import ModalModule from '../modal';
import ThinClientInterface from '../thinclient';
import { WrappedButton, WrappedButtonType } from '../ui/button';
import { WrappedDropdown } from '../ui/input';
import Utils from '../utils';

const { Modal } = ModalModule;
const { withLayoutAndModalContexts } = Utils;

class ThinClientPrintModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			printers: [],
		};

		this.getPrinters().then(printers => {
			this.setState({ printers });
		});
	}

	/**
	 * Return modal header text based on type of print and quantity
	 * @returns {string}
	 */
	getHeader = () => 'Print';

	/**
	 * Retrieve the list of printers from ThinClientInterface
	 * @returns {Array}
	 */
	getPrinters = async () => {
		const printers = await ThinClientInterface.getPrinterInfo();
		return printers;
	};

	/*
	 * Print button click handler
	 */
	onPrintClick = () => {
		const { printer, tray } = this.state;
		const {
			data: { callback },
			modalId,
		} = this.props;

		if (callback) {
			callback(printer ? printer.value : null, tray, modalId);
		}
	};

	onRefreshClick = () => {
		ThinClientInterface.refreshPrinters(filteredPrinters => {
			this.setState({ printers: filteredPrinters });
		});
	};

	render() {
		const { modalId, data } = this.props;
		const { labels } = data || {};
		const { printer, printers, tray } = this.state;
		const printerNames = printers.map(printerItem => printerItem.name);
		// find the printer object from the printers array that matches the selected printer name
		const selectedPrinter = printers.find(
			p => p.name === (printer ? printer.value : null)
		);
		// update the trays state with trays from the selected printer
		const trays = selectedPrinter ? selectedPrinter.tray : [];
		const trayNames = trays.map(trayItem => trayItem.name);

		return (
			<Modal
				modalId={modalId}
				className="common-print-modal"
				header={this.getHeader()}
				labels={labels}
				hideFooter
			>
				{/* custom body */}
				<div className="dialog-body">
					<div className="p-grid p-nogutter">
						<div className="p-col-3 label">Printer:</div>
						<div className="p-col-8">
							<WrappedDropdown
								options={printerNames}
								value={printer ? printer.value : null}
								disabled={printers.length === 0}
								onChange={value => this.setState({ printer: value })}
								label="Printer"
							/>
						</div>
						<div className="p-col-1">
							{/* refresh button */}
							{/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
							<span
								className="warning-icon pi pi-sync"
								onClick={this.onRefreshClick}
							/>
						</div>
						<div className="p-col-12">&nbsp;</div>

						<div className="p-col-3 label">Paper Tray:</div>
						<div className="p-col-9">
							<WrappedDropdown
								options={trayNames}
								value={tray || null}
								disabled={trays.length === 0}
								onChange={value => this.setState({ tray: value.value })}
								label="Tray"
							/>
						</div>
					</div>
				</div>

				{/* custom Footer */}
				<div className="p-dialog-footer custom-footer">
					<WrappedButton
						buttonType={WrappedButtonType.Primary}
						label="Print"
						onClick={this.onPrintClick}
					/>
				</div>
			</Modal>
		);
	}
}

export default withLayoutAndModalContexts(ThinClientPrintModal);
